import { createFileRoute } from '@tanstack/react-router';
import { OffersPage } from '@/features/review/pages';

// «Da importare» (ADR 0086): the trackings Dokless offers and Plancia has not imported.
export const Route = createFileRoute('/_app/shipments/import')({
  component: OffersPage,
});
